/* global G */
import { curry } from 'lib/util'
import session from 'app/_shared/session'

/**
 * Callback for removing the item from the state of the list.
 *
 * @callback removeItem
 * @param {Object[]} prevState
 * @param {Object} fetchedCart
 */

/** @type {removeItem} */
export const removeItem = (prevState, removedItem) => {
  const newState = [...prevState]
  const existingCart = prevState.find(cart => cart.key === removedItem.key)

  if (existingCart) {
    newState.splice(newState.indexOf(existingCart), 1)
  }

  return newState
}

/**
 * Callback for adding the item to the state of the list.
 *
 * @callback addItem
 * @param {Object[]} prevState
 * @param {Object} fetchedCart
 */

/** @type {addItem} */
export const addItem = (prevState, fetchedItem) => {
  const newState = removeItem(prevState, fetchedItem)

  newState.unshift(fetchedItem)

  return newState
}

/**
 * Returns whether `fetchedCart`'s `submitter` is the current user and its `status` is `80`.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Object} fetchedCart
 * @returns {*|boolean}
 */
const iAmSubmitterAndIsDone = (module, fetchedCart) => {
  const user = session(module).user.key({ wrap: true })[0]

  return fetchedCart.refs.submitter.includes(user)
    && fetchedCart.value.status === 80
}

/**
 * Returns whether `fetchedCart`'s `submitter` is the current user and its `status` is equal or less
 * than `50`.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Object} fetchedCart
 * @returns {*|boolean}
 */
const iAmSubmitterAndIsActiveOrDraft = (module, fetchedCart) => {
  const user = session(module).user.key({ wrap: true })[0]

  return fetchedCart.refs.submitter.includes(user)
    && fetchedCart.value.status <= 50
}

/**
 * Get the new cart and return it alongside
 * a callback handling the state change.
 *
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the current action's main component
 * @param event                           event containing the new cart id
 * @returns {Promise<*>}
 */
// eslint-disable-next-line no-unused-vars
const updateList = async (module, component, event) => {
  const obj = module[G.MODEL]
  const { api, version } = obj[G.PROPS]
  const cartId = event.id
  const url = `/api/v${version}/${api}/${cartId}`
  const { key: listKey } = component[G.PROPS]

  try {
    const fetchedCart = await obj[G.ADAPTER][G.HTTP].get({ url })

    return (listKey === 'history' && iAmSubmitterAndIsDone(module, fetchedCart))
    || (listKey === 'draft' && iAmSubmitterAndIsActiveOrDraft(module, fetchedCart))
      ? { item: fetchedCart, addItem }
      : { item: fetchedCart, addItem: removeItem }
  } catch (e) {
    console.error(e)
  }
  return {}
}
export default curry(updateList)
